import React from "react";
import useApi from "storybook-dashboard/utils/fetching";
import VERSION from "AppAssets/text/VERSION.txt";
import BUILD_DATE from "AppAssets/text/BUILD_DATE.txt";
import BRANCH_NAME from "AppAssets/text/BRANCH_NAME.txt";

export default function Version() {
  const { data: version } = useApi("/api/version/");

  if (!version) {
    return null;
  }
  return (
    <div>
      <h3>Current Versions</h3>
      <Track version={version} />
      <SustoolReact />
    </div>
  );
}

function SustoolReact(props) {
  return (
    <div className="mt-3">
      <h4>Sustainability Tool React</h4>
      <div className="ml-3 row">
        <div className="col-2">COMMIT:</div>
        <div className="col-6">{VERSION}</div>
      </div>
      <div className="ml-3 row">
        <div className="col-2">BUILD DATE:</div>
        <div className="col-6">{BUILD_DATE}</div>
      </div>
      <div className="ml-3 row">
        <div className="col-2">BRANCH:</div>
        <div className="col-6">{BRANCH_NAME}</div>
      </div>
    </div>
  );
}

function Track(props) {
  let { version } = props;
  return (
    <div className="mt-3">
      <h4>Track</h4>
      <div className="ml-3 row">
        <div className="col-2">DOCKER TAG:</div>
        <div className="col-6">{version.get("tag")}</div>
      </div>
      <div className="ml-3 row">
        <div className="col-2">COMMIT:</div>
        <div className="col-6">{version.get("commit")}</div>
      </div>
      <div className="ml-3 row">
        <div className="col-2">BUILD DATE:</div>
        <div className="col-6">{version.get("date")}</div>
      </div>
      <div className="ml-3 row">
        <div className="col-2">BRANCH:</div>
        <div className="col-6">{version.get("branch")}</div>
      </div>
    </div>
  );
}
